import { Entity, IFileTimesDto, UniqueEntityId } from "@kernel/ddd";
import { Stats } from "./Stats";
import { cloneDeep } from "lodash";

export interface StatsFileProps {
  name: string;
  checksum: string;
  size: number;
  fileTimes: IFileTimesDto;
  content: Stats;
}

export class StatsFile extends Entity<StatsFileProps> {
  public get name() {
    return this.props.name;
  }

  public get checksum() {
    return this.props.checksum;
  }

  public get size() {
    return this.props.size;
  }

  public get fileTimes() {
    return this.props.fileTimes;
  }

  public get content() {
    return this.props.content;
  }

  public get stats() {
    return this.props.content;
  }

  public clone(): StatsFile {
    const props = cloneDeep(this.props);
    return new StatsFile(props, new UniqueEntityId(this._id.toValue()));
  }

  public toString(): string {
    return this.name;
  }

  public static create(props: StatsFileProps, id?: UniqueEntityId): StatsFile {
    return new StatsFile(props, id);
  }
}
